// 权限类型定义，与stores/permission.ts保持一致
export enum PermissionType {
  // 配置管理相关权限
  UserEvaluation = 'config:user-evaluation',
  EvaluationItems = 'config:evaluation-item',
  // UserManage = 'config:user-manage',
  SchoolManage = 'config:school',
  AbnormalUser = 'config:abnormal-user',
  SatisfactionRule = 'config:satisfaction-rule',
  BannerConfig = 'config:banner-config',
  // 统计分析相关权限
  StatisticHome = 'stats:home',
  DetailedData = 'stats:detail',
}

// 获取所有权限类型的数组，用于超级管理员
export function getAllPermissionTypes(): PermissionType[] {
  return Object.values(PermissionType);
}

// 路由元信息接口
export interface RouteMeta {
  title: string;
  icon?: string;
  permission?: PermissionType | PermissionType[];
  hidden?: boolean;
  requireSuperAdmin?: boolean;
}

// 扩展Vue Router的路由类型
declare module 'vue-router' {
  interface RouteMeta extends Record<string | number | symbol, unknown> {
    title: string;
    icon?: string;
    permission?: PermissionType | PermissionType[];
    hidden?: boolean;
    requireSuperAdmin?: boolean;
  }
  
  interface RouteRecordSingleViewBase {
    hidden?: boolean;
  }
}